<script lang="ts">
  import RegisterForm from '$components/Forms/RegisterForm.svelte'
  // import Icon from '@iconify/svelte'
  import { t } from '$lib/translations'
  import { registerFormSchema } from '$lib/zod-schemas'
  import { superForm } from 'sveltekit-superforms/client'
  import type { PageData } from './$types'
  import { toast } from 'svelte-sonner'
  import { showLoading } from '$lib/stores/layout'

  export let data: PageData

  const { ultraForm } = data
  const form = superForm(ultraForm, {
    validators: registerFormSchema,
    taintedMessage: null,
    onSubmit() {
      if($message) $showLoading = true
    }
  })
  const { message } = form

  $: {
    // Hanled error messages
    if ($message && !$message.success && $message.message) {
      $showLoading = false
      setTimeout(() => {
        toast.error($t(`errors.${$message.message}`))
        $message = null
      }, 0)
    }

    // Handle success registration
    if ($message?.success && $message.redirect) {
      showLoading.set(true)
      location.href = $message?.redirect
    }
  }
</script>

<section class="px-0 lg:px-60 pt-20 lg:pt-20 flex-col items-center justify-center">
  <div class="flex justify-between items-center gap-10 lg:flex-row flex-col mb-14">
    <div class="benefits">
      <h2 class="font-bold mb-6 lg:mb-2 lg:text-left text-center">
        {$t('common.register_and_enjoy')}
      </h2>
      <!-- <div class="flex justify-start items-start lg:items-center gap-1 mb-1">
        <Icon
          icon="lets-icons:check-fill"
          height="14px"
          width="14px"
          color="green"
        />
        <p class="text-xs">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit?
        </p>
      </div>
      <div class="flex justify-start items-start lg:items-center gap-1 mb-1">
        <Icon
          icon="lets-icons:check-fill"
          height="14px"
          width="14px"
          color="green"
        />
        <p class="text-xs">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit?
        </p>
      </div>
      <div class="flex justify-start items-start lg:items-center gap-1 mb-1">
        <Icon
          icon="lets-icons:check-fill"
          height="14px"
          width="14px"
          color="green"
        />
        <p class="text-xs">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit?
        </p>
      </div>
      <div class="flex justify-start items-start lg:items-center gap-1 mb-1">
        <Icon
          icon="lets-icons:check-fill"
          height="14px"
          width="14px"
          color="green"
        />
        <p class="text-xs">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit?
        </p>
      </div>
      <div class="flex justify-start items-start lg:items-center gap-1 mb-1">
        <Icon
          icon="lets-icons:check-fill"
          height="14px"
          width="14px"
          color="green"
        />
        <p class="text-xs">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit?
        </p>
      </div> TODO faltan los lang para eso -->
    </div>
  </div>
  <hr class="my-14" />
  <div class="w-[95%] flex items-center justify-center mx-auto">
    <RegisterForm {form} />
  </div>
  <div>
    <p class="my-4 text-xs text-justify">{@html $t('common.basic_information_on_data_protection')}</p>
  </div>
</section>

<style>
  hr {
    background-color: grey;
    height: 2px;
  }
</style>
